if (!customElements.get('editorial-intro')) {
  class EditorialIntro extends HTMLElement {
    connectedCallback() {
      if (
        this.classList.contains('is-revealed') ||
        window.Shopify?.designMode ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)
      ) return;

      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.15 });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('editorial-intro', EditorialIntro);
}
